import { TranslationObject } from '../../i18n/translation';

const namespace = 'praksisstedsok';

const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Finn praksissted i hierarki',
    en: 'Find practice place in hierarchy',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Søk etter praksissteder, se hvor de befinner seg i hierarkiet og om de har en sterk tilknytning til praksis.',
    en: 'Search for practice places, see how they relate to others in the hierarchy, and check for affilitation to student practice.',
  },
  searchHeaderTitle: {
    id: `${namespace}.searchHeaderTitle`,
    nb: 'Praksisstedsøk',
    en: 'Practice place search',
  },
  searchHeaderSubtitle: {
    id: `${namespace}.searchHeaderSubtitle`,
    nb: 'Søk etter praksissteder som finnes i Arbeidslivsportalen per i dag. Man kan sette grense for antall hentede resultater og om man kun vil se gjeldende praksissteder.',
    en: 'Search for practice places that exist in Arbeidslivsportalen today. You may choose a limit for the no. of fetched results, as well as choose to fetch only current practice places.',
  },
  searchLabel: {
    id: `${namespace}.searchLabel`,
    nb: 'Søk etter eksisterende praksissteder',
    en: 'Search for existing practice places',
  },
  searchPlaceholder: {
    id: `${namespace}.searchPlaceholder`,
    nb: 'Søk etter praksisstedets navn eller kode',
    en: 'Search for the practice place name or code',
  },
  searchBtn: {
    id: `${namespace}.searchBtn`,
    nb: 'Søk',
    en: 'Search',
  },
  limitLabel: {
    id: `${namespace}.limitLabel`,
    nb: 'Maks. antall resultater',
    en: 'Max. no. results',
  },
  limitPlaceholder: {
    id: `${namespace}.limitPlaceholder`,
    nb: 'Maks. antall resultater å hente ({ min }-{ max })...',
    en: 'Max. number of results to retrieve ({ min }-{ max })...',
  },
  limitHitWarning: {
    id: `${namespace}.limitHitWarning`,
    nb: 'Det er returnert maks. antall resultater. Noen matchende praksissteder kan mangle i resultatlisten. Prøv å snevre inn søket eller å øke grensen for maks. antall resultater.',
    en: 'The max. no. results has been returned. Some matching practice places may be missing from the resulting list. Try to narrow down the search or increase the max. no. results.',
  },
  gjeldendeOnlyCheckbox: {
    id: `${namespace}.gjeldendeOnlyCheckbox`,
    nb: 'Søk kun etter gjeldende (ikke-deaktiverte) praksissteder',
    en: 'Search only for current practice places (not deactivated ones)',
  },
  matchingPraksisstedDialogTitle: {
    id: `${namespace}.matchingPraksisstedDialogTitle`,
    nb: 'Praksissteder som matcher søket',
    en: 'Practice places matching the search',
  },
  matchingPraksisstedDialogSubtitle: {
    id: `${namespace}.matchingPraksisstedDialogSubtitle`,
    nb: 'En liste over alle praksisstedene som stemmer overens med søket og valgene som er satt.',
    en: 'A list showing all practice places retrieved from the search and the set parameters.',
  },
  matchingPraksisstedDialogNavn: {
    id: `${namespace}.matchingPraksisstedDialogNavn`,
    nb: 'Praksisstednavn: { navn }',
    en: 'Practice place name: { navn }',
  },
  matchingPraksisstedDialogKode: {
    id: `${namespace}.matchingPraksisstedDialogKode`,
    nb: 'Praksisstedkode: { kode }',
    en: 'Practice place code: { kode }',
  },
  matchingPraksisstedDialogSubmit: {
    id: `${namespace}.matchingPraksisstedDialogSubmit`,
    nb: 'Bekreft valg',
    en: 'Confirm choice',
  },
  matchingPraksisstedDialogNoResultTitle: {
    id: `${namespace}.matchingPraksisstedDialogNoResultTitle`,
    nb: 'Ingen praksissteder funnet',
    en: 'No practice places found',
  },
  matchingPraksisstedDialogNoResultText: {
    id: `${namespace}.matchingPraksisstedDialogNoResultText`,
    nb: 'Det finnes ingen praksissteder i Arbeidslivsportalen som stemmer overens med søket. Prøv på nytt.',
    en: 'There are no practice places in Arbeidslivsportalen matching the current search. Try again.',
  },
  praksisstedTreeTitle: {
    id: `${namespace}.praksisstedTreeTitle`,
    nb: 'Informasjon om praksisstedet { navn }',
    en: 'Information regarding the practice place { navn }',
  },
  praksisstedTreeSubtitle: {
    id: `${namespace}.praksisstedTreeSubtitle`,
    nb: 'Informasjon om { navn } vises her vha. en trestruktur, som viser om, og i så fall hvordan, aktiviteter, bestillinger, besvarelser, brukere etc. avhenger av praksisstedet. Man kan både dra og zoome inn/ut i trestrukturen, samt klikke på praksisstedene for å se en mer detaljert informasjon om hvert sted.',
    en: 'Information about { navn } is presented via. a tree structure that shows if, and in that case how, activities, orders, responses, users etc. are dependent on the practice place. The tree has both drag and zoom functionality, and each practice place can be clicked for a more detailed description.',
  },
  praksisstedTreeEmptyTitle: {
    id: `${namespace}.praksisstedTreeEmptyTitle`,
    nb: 'Fant ikke praksisstedet',
    en: 'The practice place was not found',
  },
  praksisstedTreeEmptyText: {
    id: `${namespace}.praksisstedTreeEmptyText`,
    nb: 'Klarte ikke å finne praksisstedet. Prøv på nytt.',
    en: 'Could not find the practice place. Try again.',
  },
  praksisstedTreeNodeMainRelevant: {
    id: `${namespace}.praksisstedTreeNodeMainRelevant`,
    nb: 'Valgt praksissted (bør ikke slettes)',
    en: 'Chosen practice place (should not be deleted)',
  },
  praksisstedTreeNodeMainIrrelevant: {
    id: `${namespace}.praksisstedTreeNodeMainIrrelevant`,
    nb: 'Valgt praksissted (kan slettes)',
    en: 'Chosen practice place (may be deleted)',
  },
  praksisstedTreeNodeRelevant: {
    id: `${namespace}.praksisstedTreeNodeRelevant`,
    nb: 'Praksisstedet bør ikke slettes',
    en: 'The practice place should not be deleted',
  },
  praksisstedTreeNodeIrrelevant: {
    id: `${namespace}.praksisstedTreeNodeIrrelevant`,
    nb: 'Praksisstedet kan slettes',
    en: 'The practice place may be deleted',
  },
  praksisstedTreeOvernode: {
    id: `${namespace}.praksisstedTreeOvernode`,
    nb: 'Foreldernode',
    en: 'Parent node',
  },
  none: {
    id: `${namespace}.none`,
    nb: 'Ingen',
    en: 'None',
  },
  close: {
    id: `${namespace}.close`,
    nb: 'Lukk',
    en: 'Close',
  },
  yes: {
    id: `${namespace}.yes`,
    nb: 'Ja',
    en: 'Yes',
  },
  no: {
    id: `${namespace}.no`,
    nb: 'Nei',
    en: 'No',
  },
  modalTitle: {
    id: `${namespace}.modalTitle`,
    nb: 'Informasjon om { navn }',
    en: 'Information regarding { navn }',
  },
  modalNavn: {
    id: `${namespace}.modalNavn`,
    nb: 'Praksisstednavn:',
    en: 'Practice place name:',
  },
  modalKode: {
    id: `${namespace}.modalKode`,
    nb: 'Praksisstedkode:',
    en: 'Practice place code:',
  },
  modalPraksisstedId: {
    id: `${namespace}.modalPraksisstedId`,
    nb: 'PraksisstedId:',
    en: 'Practice place id:',
  },
  modalAktiv: {
    id: `${namespace}.modalAktiv`,
    nb: 'Aktiv:',
    en: 'Active:',
  },
  modalNivaa: {
    id: `${namespace}.modalNivaa`,
    nb: 'Nivå (1 er toppnivå):',
    en: 'Level (1 is at the top):',
  },
  modalRelevant: {
    id: `${namespace}.modalRelevant`,
    nb: 'Har relevant informasjon registrert på seg:',
    en: 'Has relevant information registered on self:',
  },
  modalRelevanteUndernoder: {
    id: `${namespace}.modalRelevanteUndernoder`,
    nb: 'Har relevant informasjon registrert på undernoder:',
    en: 'Has relevant information registered on children nodes:',
  },
  modalRelevantWarning: {
    id: `${namespace}.modalRelevantWarning`,
    nb: 'OBS: Vær varsom ved sletting, endring eller flytting av dette praksisstedet.',
    en: 'Caution: Be careful when deleting, editing or moving this practice place.',
  },
  modalOvernodeWarning: {
    id: `${namespace}.modalOvernodeWarning`,
    nb: 'Merk: Ved visning av overnode kan det mangle informasjon i vinduet, ettersom informasjon utenfor stien til praksisstedet man har søkt på ignoreres.',
    en: 'Note: When showing information regarding a parent node, only information relating to the main searched for practice place is shown. Sibling information is ignored.',
  },
  modalAvtaleNavn: {
    id: `${namespace}.modalAvtaleNavn`,
    nb: 'Avtalenavn:',
    en: 'Agreement name:',
  },
  modalAvtaleId: {
    id: `${namespace}.modalAvtaleId`,
    nb: 'AvtaleId:',
    en: 'Agreement Id:',
  },
  modalAvtaleStart: {
    id: `${namespace}.modalAvtaleStart`,
    nb: 'Avtalestart:',
    en: 'Agreement start:',
  },
  modalAvtaleSlutt: {
    id: `${namespace}.modalAvtaleSlutt`,
    nb: 'Avtaleslutt:',
    en: 'Agreement end:',
  },
  modalAvtaleAktiv: {
    id: `${namespace}.modalAvtaleAktiv`,
    nb: 'Aktiv:',
    en: 'Active:',
  },
  modalAvtaler: {
    id: `${namespace}.modalAvtaler`,
    nb: 'Avtaler',
    en: 'Agreements:',
  },
  modalAvtalerSted: {
    id: `${namespace}.modalAvtalerSted`,
    nb: 'Avtaler ved praksisstedet:',
    en: 'Agreements at practice place:',
  },
  modalAvtalerUndernoder: {
    id: `${namespace}.modalAvtalerUndernoder`,
    nb: 'Avtaler ved praksisstedets undernoder:',
    en: 'Agreements at practice place children:',
  },
  modalBestillingAvtaleSted: {
    id: `${namespace}.modalBestillingAvtaleSted`,
    nb: 'Bestilling ved Avtalested',
    en: 'Order at agreement place',
  },
  modalBestillingOmfattetSted: {
    id: `${namespace}.modalBestillingOmfattetSted`,
    nb: 'Bestilling ved omfattet praksissted',
    en: 'Order at included agreement place',
  },
  modalBestillingId: {
    id: `${namespace}.modalBestillingId`,
    nb: 'BestillingId:',
    en: 'Order Id:',
  },
  modalBestillingDelt: {
    id: `${namespace}.modalBestillingDelt`,
    nb: 'Delt:',
    en: 'Shared:',
  },
  modalAktivitetId: {
    id: `${namespace}.modalAktivitetId`,
    nb: 'AktivitetId:',
    en: 'Activity Id:',
  },
  modalBestillingModus: {
    id: `${namespace}.modalBestillingModus`,
    nb: 'Bestillingsmodus:',
    en: 'Order mode:',
  },
  modalBestillingAntall: {
    id: `${namespace}.modalBestillingAntall`,
    nb: 'Antall bestillinger:',
    en: 'No. orders:',
  },
  modalBestillinger: {
    id: `${namespace}.modalBestillinger`,
    nb: 'Bestillinger',
    en: 'Orders',
  },
  modalBestillingerVedPraksissted: {
    id: `${namespace}.modalBestillingerVedPraksissted`,
    nb: 'Bestillinger ved praksisstedet:',
    en: 'Orders at practice place:',
  },
  modalBestillingerRelevant: {
    id: `${namespace}.modalBestillingerRelevant`,
    nb: 'Relevante bestillinger for praksisstedet:',
    en: 'Orders relevant for practice place:',
  },
  modalBesvarelseId: {
    id: `${namespace}.modalBesvarelseId`,
    nb: 'BesvarelseId:',
    en: 'Answer Id:',
  },
  modalBesvarelseKapasitet: {
    id: `${namespace}.modalBesvarelseKapasitet`,
    nb: 'Innmeldt kapasitet:',
    en: 'Capacity:',
  },
  modalBesvarelser: {
    id: `${namespace}.modalBesvarelser`,
    nb: 'Besvarelser',
    en: 'Answers',
  },
  modalBesvarelserVedPraksissted: {
    id: `${namespace}.modalBesvarelserVedPraksissted`,
    nb: 'Besvarelser ved praksisstedet:',
    en: 'Answers at practice place:',
  },
  modalBesvarelserVedUndernoder: {
    id: `${namespace}.modalBesvarelserVedUndernoder`,
    nb: 'Besvarelser ved praksisstedets undernoder:',
    en: 'Answers at practice place children:',
  },
  modalStudentPraksisplassId: {
    id: `${namespace}.modalStudentPraksisplassId`,
    nb: 'StudentPraksisplassId:',
    en: 'Student Practice place Id:',
  },
  modalStudentPraksisplassStudentPraksisklasseId: {
    id: `${namespace}.modalStudentPraksisplassStudentPraksisklasseId`,
    nb: 'StudentPraksisklasseId:',
    en: 'Student Practice class Id:',
  },
  studentPraksisplassTitle: {
    id: `${namespace}.studentPraksisplassTitle`,
    nb: 'Studenter med tildelte praksisplasser',
    en: 'Students assigned to practice places',
  },
  modalStudentPraksisplassVedPraksissted: {
    id: `${namespace}.modalStudentPraksisplassVedPraksissted`,
    nb: 'Studenter med tildelt praksisplass ved praksisstedet:',
    en: 'Students assigned to practice place:',
  },
  modalStudentPraksisplassVedUndernoder: {
    id: `${namespace}.modalStudentPraksisplassVedUndernoder`,
    nb: 'Studenter med tildelt praksisplass ved praksisstedets undernoder:',
    en: 'Students assigned to practice place children:',
  },
  modalPraksisstedTilgangAdmin: {
    id: `${namespace}.modalPraksisstedTilgangAdmin`,
    nb: 'Administrator',
    en: 'Administrator',
  },
  modalPraksisstedTilgangWrite: {
    id: `${namespace}.modalPraksisstedTilgangWrite`,
    nb: 'Skriverettighet',
    en: 'Write access',
  },
  modalPraksisstedTilgangRead: {
    id: `${namespace}.modalPraksisstedTilgangRead`,
    nb: 'Leserettighet',
    en: 'Read access',
  },
  modalPraksisstedTilgangBrukerId: {
    id: `${namespace}.modalPraksisstedTilgangBrukerId`,
    nb: 'BrukerId:',
    en: 'User Id:',
  },
  modalPraksisstedTilgangType: {
    id: `${namespace}.modalPraksisstedTilgangType`,
    nb: 'Tilgangstype:',
    en: 'Access level:',
  },
  modalPraksisstedTilgangTitle: {
    id: `${namespace}.modalPraksisstedTilgangTitle`,
    nb: 'Brukere med tilgang',
    en: 'Users with access',
  },
  modalPraksisstedTilgangVedPraksissted: {
    id: `${namespace}.modalPraksisstedTilgangVedPraksissted`,
    nb: 'Brukere med tilgang ved praksisstedet:',
    en: 'Users with access at practice place:',
  },
  modalPraksisstedTilgangVedUndernoder: {
    id: `${namespace}.modalPraksisstedTilgangVedUndernoder`,
    nb: 'Brukere med tilgang ved praksisstedets undernoder:',
    en: 'Users with access at practice place children:',
  },
  avtale: {
    id: `${namespace}.avtale`,
    nb: 'Avtale',
    en: 'Contract',
  },
  bestilling: {
    id: `${namespace}.bestilling`,
    nb: 'Bestilling',
    en: 'Order',
  },
  besvarelse: {
    id: `${namespace}.besvarelse`,
    nb: 'Besvarelse', // (Innmeldt kapasitet)
    en: 'Response', // (Reported capacity)
  },
  helpTitle: {
    id: `${namespace}.helpTitle`,
    nb: 'Hjelp og veiledning',
    en: 'Help and advice',
  },
  helpSubtitle: {
    id: `${namespace}.helpSubtitle`,
    nb: 'Hvis man ønsker å gjøre endringer på et praksissted, bør man tenke gjennom punktene under.',
    en: 'If one wishes to make changes to a practice place, please consider the advice below.',
  },
  helpAvtaleParagraph: {
    id: `${namespace}.helpAvtaleParagraph`,
    nb: 'Informer kontaktpersoner for institusjoner som har avtale med praksisstedet. Bli enige om mulige endringer som må gjøres i avtalen, slik at det ikke dukker opp noen overraskelser for studiestedet.',
    en: 'Inform the contact persons at the institution that has a contract with the practice place. Agree upon possible changes to the contract to avoid surprises for the institution.',
  },
  helpBestillingParagraph1: {
    id: `${namespace}.helpBestillingParagraph1`,
    nb: 'Meld fra til kontaktpersoner ved institusjoner som har bestillinger ved praksisstedet. Hvis en bestilling ikke er delt, kan studiestedbrukere løse konflikter ved å sette bestillingen til 0 og lagre. Avtalen kan fortsatt skape konflikt. Se punktet over.',
    en: 'Notify contact persons at the institutions that has orders at the practice place. If an order is not shared, users at the institution can solve conflicts by setting the order to 0 and saving. The contract can still create conflicts. See the paragraph above.',
  },
  helpBestillingParagraph2: {
    id: `${namespace}.helpBestillingParagraph2`,
    nb: 'Hvis en bestilling er delt, bør det ikke gjøres endringer, siden dette ikke støttes godt i applikasjonen. Endringer må per dags dato gjøres manuelt av utviklerene. Varsler til berørte praksissteder må også håndteres manuelt.',
    en: 'If the order is shared, changes should not be made since this is not well supported by the application. Changes must be made manually by the developers. Notifying the practice places must also be done manually.',
  },
  helpBesvarelseParagraph: {
    id: `${namespace}.helpBesvarelseParagraph`,
    nb: 'Meld fra til kontaktpersoner for institusjoner som har besvarelser (innmeldt kapasitet) ved praksisstedet. Dersom kapasitet er bekreftet, bør ikke endringer gjøres. Endringer må per dags dato gjøres manuelt av utviklerene. Varsler til berørte praksissteder må også håndteres manuelt.',
    en: 'Notify contact persons at the institutions that has responses (reported capacity) at the practice place. If capacity is confirmed, changes should not be made. Changes must be made manually by the developers. Notifying the practice places must also be done manually.',
  },
  helpTildeltePlasserParagraph: {
    id: `${namespace}.helpTildeltePlasserParagraph`,
    nb: 'Meld fra til kontaktpersoner for institusjoner som har studenter fordelt til praksisstedet. Dersom studenter er fordelte til praksisstedet, bør ikke endringer gjøres. Endringer må per dags dato gjøres manuelt av utviklerene. Varsler til berørte praksissteder og studenter må også håndteres manuelt.',
    en: 'Notify contact persons at the institutions that has students assigned to the practice place. If there are students assigned to the practice place, changes should not be made. Changes must be made manually by the developers. Notifying the practice places and students must also be done manually.',
  },
  helpBrukereTilgangTitleParagraph: {
    id: `${namespace}.helpBrukereTilgangTitleParagraph`,
    nb: 'Brukere med tilgang',
    en: 'Users with access',
  },
  helpBrukereTilgangParagraph: {
    id: `${namespace}.helpBrukereTilgangParagraph`,
    nb: 'Dersom det finnes brukere med tilgang ved prakssisstedet, bør de kontaktes. Finn ut om brukerne kan få nye tilganger, eller om de kan fjernes.',
    en: 'If there are users that has access at the practice place, they should be notified. Figure out if the user can get new types of access, or if they can be removed.',
  },
};

export default translations;
